import {
  AvoSelect,
  AvoSelectItem,
  AvoSelectItembox,
  AvoSelectTrigger,
} from 'components/utils/AvoSelect';
import { Icons } from 'components/utils/Icons';

export function ApiOutputItemBooleanSelect({
  value,
  onChange,
}: {
  value: boolean;
  onChange: (value: boolean) => void;
}) {
  return (
    <AvoSelect onChange={onChange} value={value}>
      <AvoSelectTrigger>
        {({ isOpen }) => (
          <div className='flex items-center justify-between gap-1 border-b border-gray-300 px-2 py-1'>
            <span>{value + ''}</span>
            <Icons.CaretDown className={`transition-all ${isOpen ? 'rotate-180' : ''}`} />
          </div>
        )}
      </AvoSelectTrigger>
      <AvoSelectItembox className='z-10 rounded bg-white shadow-04'>
        {[true, false].map((boolValue, idx) => (
          <AvoSelectItem value={boolValue} key={idx} className='p-2 hover:bg-primary-300'>
            {({ isSelected }) => (
              <div className='flex justify-between'>
                <span>{boolValue.toString()}</span>
                {isSelected && <span className='text-primary-500'>✓</span>}
              </div>
            )}
          </AvoSelectItem>
        ))}
      </AvoSelectItembox>
    </AvoSelect>
  );
}
